import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationService } from "./../core/application.service";
import { AppConfig } from '../../models/core/app-config';

@Injectable()
export class LanguageService {

    private lang: string;

    constructor
        (
            private translate: TranslateService,
            private appService: ApplicationService
        ) { 
            this.lang = this.translate.currentLang || this.translate.getDefaultLang();
        }

    getLongLang(): string {
        var lang = 'it-IT';
        switch (this.lang) {
            case 'it': lang = 'it-IT';
                break;
            case 'en': lang = 'en-GB';
                break;
            case 'al': lang = 'sq-AL';
                break;
            case 'de': lang = 'de-DE';
                break;
            case 'sl': lang = 'sl-SI';
                break;
            case 'hr': lang = 'hr-HR';
                break;
            case 'pt': lang = 'pt-PT';
                break;
            case 'es': lang = 'es-ES';
                break;
            case 'fr': lang = 'fr-FR';
                break;
            case 'pl': lang = 'pl-PL';
                break;
            case 'tr': lang = 'tr-TR';
                break;
        }
        return lang;
    }

    getShortLang(): string {
        return this.lang;
    }
}

export class LanguageObj {
    ShortCode: string;
    LongCode: string;
    Text: string;
    IconCode: string;
    ImageUrl: string;
}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/language.service.ts